<template>
    <div class="container">
        <div class="rightAlert" v-if="show">
            <div class="innerbox">
                <div class="img"><img src="../assets/images/icon_tips_success.png" alt="" srcset=""></div>
                <div class="span">Your request <br> was successfully submitted.</div>
                <div class="close" @click="close('true', $event)"><svg version="1.1" id="图层_1"
                        xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                        viewBox="0 0 20.71 20.7" style="enable-background:new 0 0 20.71 20.7;fill:#898989"
                        xml:space="preserve">

                        <g>
                            <g>
                                <path class="st0"
                                    d="M14.24,10.43l5.68-5.68c1.05-1.05,1.05-2.74,0-3.79c-1.05-1.05-2.74-1.05-3.78,0l-5.68,5.68L4.61,0.79
			c-1.06-1.06-2.77-1.06-3.82,0c-1.06,1.06-1.06,2.77,0,3.82l5.85,5.85L1,16.11c-1.05,1.05-1.05,2.74,0,3.79
			c1.05,1.05,2.74,1.05,3.78,0l5.64-5.64l5.66,5.66c1.06,1.06,2.77,1.06,3.82,0c1.06-1.06,1.06-2.77,0-3.82L14.24,10.43z" />
                            </g>
                        </g>
                    </svg></div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            show: false
        }
    },
    methods: {
        open() {
            console.log("222");
            this.show = true
            setTimeout(() => {
                document.querySelectorAll(".rightAlert")[0].style.opacity = 1
            }, 500);

        },
        close(value, el) {
            document.querySelectorAll(".rightAlert")[0].style.opacity = 0

            if (value == 'hand') {
                this.show = false

            }
            setTimeout(() => {
                this.show = false
            }, 500);
        },
    }
}
</script>
